
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.353 6.4a.75.75 0 01.75-.75h13.422a.75.75 0 01.75.75v8.255a.75.75 0 01-.75.75h-5.809a19.802 19.802 0 00-.601 1.908c-.166.642-.256 1.166-.256 1.469 0 .344.087.814.424 1.192.321.36.983.764 2.4.764a.75.75 0 010 1.5c-1.71 0-2.835-.498-3.52-1.266-.668-.75-.804-1.633-.804-2.19 0-.505.133-1.183.303-1.843.13-.506.292-1.038.462-1.534h-6.02a.75.75 0 01-.75-.75v-1.268l-2.544 1.27a.75.75 0 01-1.085-.671V7.069a.75.75 0 011.086-.67L6.353 7.67V6.4zm1.5.75v6.755h11.922V7.15H7.853zM4.225 8.283v4.49l1.958-.978V9.263l-1.958-.98z"}})])
          )
        }
      }
    